import { useReducer } from 'react';
import { HelpWith } from '@components/basicComponents';
import { HelpWithType } from '@customTypes/enums';
import type { FormFieldsProps } from '@customTypes/types';
import type { NetworkingArubaCentralFormFieldsState } from '@customTypes/stateTypes';
import { helpWithOptions } from './NetworkingArubaCentralFormOptions';

export const NetworkingArubaCentralFormFields = (props: FormFieldsProps): JSX.Element => {
  const [state, updateState] = useReducer(
    (prev: NetworkingArubaCentralFormFieldsState, newState: Partial<NetworkingArubaCentralFormFieldsState>) => ({
      ...prev,
      ...newState,
    }),
    {
      helpWith: ''
    }
  );

  const helpWithChange = (option: string): void => {
    if (option === state.helpWith) {
      return;
    }

    clearFirstSelectState();
    updateState({ helpWith: option });
    props.onDetailsChange({ showDetails: true });

    if (option === helpWithOptions.arubaTechnicalTeam) {
      window.open('https://networkingsupport.hpe.com/', '_blank');
      window.location.reload();
    }
  };

  const clearState = (): void => {
    clearFirstSelectState();
    updateState({ helpWith: '' });
  };

  props.onReset && props.onReset(clearState);

  const clearFirstSelectState = (): void => {
    props.onDetailsChange({ showDetails: false });
  };

  return (
    <>
      <HelpWith
        selectType={!props.isConsolidated ? HelpWithType.First : HelpWithType.Second}
        options={Object.values(helpWithOptions)}
        onChange={helpWithChange}
      />
    </>
  );
};
